<template>
  <div>
    <div class="section-three">
      <div class="section-bg">
        <img src="@/assets/images/banner_3.jpg" alt />
      </div>
      <div class="container">
        <div class="container-img">
          <div class="con-img first">
            <img src="@/assets/images/image_step_1.png" alt="">
          </div>
          <div class="con-img second">
            <img src="@/assets/images/image_step_2.png" alt="">
          </div>
          <div class="con-img third">
            <img src="@/assets/images/image_step_3.png" alt="">
          </div>
        </div>
        <div class="container-footer">
          <div class="footer">
            <div class="icon">
              <img src="@/assets/images/icon_live_24.png" alt="">
            </div>
            <div class='icon-con'>
              <span>入驻流程</span>
              <span>三步轻松入驻格局云</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionThree"
};
</script>

<style lang="css" scoped>
.section-three{
  width:100%;
  height:100%;
  overflow:hidden;
}
.section-bg{
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index:30;
}
.section-bg img{
  width:100%;
  height:100%;
}
.container{
  width:100%;
  height:100%;
  box-sizing: border-box;
}
.container-img{
  width:69%;
  height:100%;
  display:flex;
  justify-content: space-around;
  align-items:center;
  position:absolute;
  left:50%;
  top: 0;
  transform:translateX(-50%);
  z-index:60;
}
.container-img .con-img{
  width:321px;
  height:665px;
}
.container-img .con-img img{
  width:100%;
  height:100%;
}
.container-img .con-img img{
  transition:transform 1s;
}
.container-img .con-img.first:first-child img{
  transform: translateX(-680px);
  animation-delay:0s;
}
.container-img .con-img.second:nth-last-of-type(2) img{
  transform: translateX(-1288px);
  animation-delay:3s;
}
.container-img .con-img.third:last-child img{
  transform: translateX(688px);
  animation-delay:5s;
}
.container-img .con-img.first.current img,.container-img .con-img.second.current img,.container-img .con-img.third.current img{
  transform: none
}
.container .container-footer{
  width:100%;
  height:60px;
  background:#0e050a;
  opacity:.8;
  position:absolute;
  bottom:0;
  z-index:2;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items:center;
  z-index:1000;
}
.footer{
  width:69%;
  height:100%;
  align-self:flex-start;
  display:flex;
  align-items:center;
  padding-left:111px;
  
}
.icon{
  padding-right:5px;
}
.icon img{
  width:36px;
  height:36px;
}
.icon-con{
  height:36px;
  display:flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left:5px;
  border-left:1px solid #fff;
}
.icon-con span{
  align-self:flex-start;
}
</style>
